import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBAnimation, MDBCard, MDBCardBody, MDBRow } from "mdbreact";
import TableLoading from "../../../../components/tableLoading";
import {
  BROWSE,
} from "../../../../services/redux/slices/diagnostics/clinic/dailyCollections";
import CollectionsHeader from "./header";
import CollectionsTabs from "./tabs";
import ListPanel from "./listPanel";
import AnalyticsPanel from "./analyticsPanel";

const DailyCollections = () => {
  const dispatch = useDispatch();
  const { token } = useSelector(({ auth }) => auth);
  const { reportDate, activeTab, isLoading, lastFetchedDate } = useSelector(
    ({ dailyCollections }) => dailyCollections,
  );

  useEffect(() => {
    if (!token || !reportDate) return;
    if (lastFetchedDate === reportDate) return;

    dispatch(
      BROWSE({
        token,
        data: { date: reportDate },
      }),
    );
  }, [dispatch, token, reportDate, lastFetchedDate]);

  return (
    <MDBAnimation type="fadeIn">
      <MDBCard narrow className="pb-3">
        <MDBCardBody>
          <CollectionsHeader />
          <MDBRow>
            <CollectionsTabs />
            {isLoading && !lastFetchedDate ? (
              <TableLoading />
            ) : activeTab === "analytics" ? (
              <AnalyticsPanel />
            ) : (
              <ListPanel />
            )}
          </MDBRow>
        </MDBCardBody>
      </MDBCard>
    </MDBAnimation>
  );
};

export default DailyCollections;
